// extracted by mini-css-extract-plugin
export default {"cards":"Users_cards__mOWFn","main":"Users_main__C7Jgc","table":"Users_table__fqv13"};